module.exports = __webpack_public_path__ + "static/img/archer.ac28086.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/scoiatael/archer.png
// module id = hqaa
// module chunks = 0